import {
  IsBoolean,
  IsInt,
  IsNotEmpty,
  IsObject,
  IsOptional,
  IsString,
  Length,
  Max,
  MaxLength,
  Min,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { Type } from 'class-transformer'
import {
  MAX_ACTIVITY_TYPE_CODE_LENGTH,
  MAX_ACTIVITY_TYPE_LABEL_LENGTH,
  MAX_ACTIVITY_TYPE_DESCRIPTION_LENGTH,
} from '../../../constants/activity-type.constants'


export class CreateActivityTypeRequestDto {
  @ApiProperty({
    description: "Code unique du type d'activité",
    example: 'quiz_mcq',
    maxLength: MAX_ACTIVITY_TYPE_CODE_LENGTH,
  })
  @IsNotEmpty()
  @IsString()
  @Length(2, MAX_ACTIVITY_TYPE_CODE_LENGTH)
  code!: string

  @ApiProperty({
    description: "Libellé du type d'activité",
    example: 'Quiz à choix multiples',
    maxLength: MAX_ACTIVITY_TYPE_LABEL_LENGTH,
  })
  @IsNotEmpty()
  @IsString()
  @MaxLength(MAX_ACTIVITY_TYPE_LABEL_LENGTH)
  label!: string

  @ApiPropertyOptional({
    description: "Description détaillée du type d'activité",
    maxLength: MAX_ACTIVITY_TYPE_DESCRIPTION_LENGTH,
    type: 'string',
  })
  @IsOptional()
  @IsString()
  @MaxLength(MAX_ACTIVITY_TYPE_DESCRIPTION_LENGTH)
  description?: string

  @ApiProperty({
    description: "Schéma JSON de validation du contenu de l'activité",
    example: { type: 'object', properties: {} },
  })
  @IsNotEmpty()
  @IsObject()
  jsonSchema!: Record<string, any>

  @ApiProperty({
    description: "Configuration par défaut pour ce type d'activité",
    example: { theme: 'light', layout: 'standard' },
  })
  @IsNotEmpty()
  @IsObject()
  defaultConfig!: Record<string, any>

  @ApiPropertyOptional({
    description: 'Le type supporte-t-il la notation automatique ?',
    default: true,
  })
  @IsOptional()
  @IsBoolean()
  supportsAutoGrading?: boolean

  @ApiPropertyOptional({
    description: 'Le type supporte-t-il les tentatives multiples ?',
    default: true,
  })
  @IsOptional()
  @IsBoolean()
  supportsRetries?: boolean

  @ApiPropertyOptional({
    description: 'Nombre maximum de tentatives autorisées (null = illimité)',
    example: 3,
  })
  @IsOptional()
  @Type(() => Number)
  @IsInt({ message: 'Le nombre de tentatives doit être un entier' })
  @Min(1)
  @Max(999)
  maxAttempts?: number

  @ApiPropertyOptional({
    description: 'Icône représentant ce type (nom ou code)',
    example: 'quiz',
    maxLength: 64,
  })
  @IsOptional()
  @IsString()
  @MaxLength(64)
  icon?: string

  @ApiPropertyOptional({
    description: 'Couleur associée au type (format hex)',
    example: '#3B82F6',
    maxLength: 7,
  })
  @IsOptional()
  @IsString()
  @MaxLength(7)
  color?: string

  @ApiPropertyOptional({
    description: "Catégorie du type d'activité",
    example: 'assessment',
    maxLength: 64,
  })
  @IsOptional()
  @IsString()
  @MaxLength(64)
  category?: string

  @ApiPropertyOptional({
    description: 'Le type est-il actif ?',
    default: true,
  })
  @IsOptional()
  @IsBoolean()
  isActive?: boolean

  @ApiPropertyOptional({
    description: 'Le type est-il un exercice ?',
    default: true,
  })
  @IsOptional()
  @IsBoolean()
  isExercice?: boolean
}
